import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import DocumentTemplatesAPI from '../../api/documentTemplates';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getDocumentTemplates(_state) {
    return _state.records.sort((a, b) => a.name.localeCompare(b.name));
  },
  getDocumentTemplate: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isFetching: true });
    try {
      const response = await DocumentTemplatesAPI.get();
      commit(types.SET_DOCUMENT_TEMPLATES, response.data.payload);
    } finally {
      commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
  show: async ({ commit }, id) => {
    const response = await DocumentTemplatesAPI.show(id);
    commit(types.EDIT_DOCUMENT_TEMPLATE, response.data);
    return response.data;
  },
  create: async ({ commit }, templateObj) => {
    commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isCreating: true });
    try {
      const response = await DocumentTemplatesAPI.create(templateObj);
      commit(types.ADD_DOCUMENT_TEMPLATE, response.data);
      return response.data;
    } finally {
      commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isUpdating: true });
    try {
      const response = await DocumentTemplatesAPI.update(id, updateObj);
      commit(types.EDIT_DOCUMENT_TEMPLATE, response.data);
      return response.data;
    } finally {
      commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isDeleting: true });
    try {
      await DocumentTemplatesAPI.delete(id);
      commit(types.DELETE_DOCUMENT_TEMPLATE, id);
    } finally {
      commit(types.SET_DOCUMENT_TEMPLATE_UI_FLAG, { isDeleting: false });
    }
  },
  preview: async (_, { id, generableType, generableId, body, pageConfig }) => {
    const response = await DocumentTemplatesAPI.preview(id, {
      generableType,
      generableId,
      body,
      pageConfig,
    });
    return response.data.html;
  },
  generate: async (_, { id, generableType, generableId }) => {
    const response = await DocumentTemplatesAPI.generate(id, {
      generableType,
      generableId,
    });
    return response.data;
  },
};

export const mutations = {
  [types.SET_DOCUMENT_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_DOCUMENT_TEMPLATES]: MutationHelpers.set,
  [types.ADD_DOCUMENT_TEMPLATE]: MutationHelpers.create,
  [types.EDIT_DOCUMENT_TEMPLATE]: MutationHelpers.update,
  [types.DELETE_DOCUMENT_TEMPLATE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
